export const PAGINATION_PAGE_SIZE = 20;
export const PAGINATION_CURRENT_PAGE = 1;
